import { render, staticRenderFns } from "./ForumDashboard.vue?vue&type=template&id=4134a957&scoped=true"
import script from "./ForumDashboard.vue?vue&type=script&lang=ts"
export * from "./ForumDashboard.vue?vue&type=script&lang=ts"
import style0 from "./ForumDashboard.vue?vue&type=style&index=0&id=4134a957&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4134a957",
  null
  
)

export default component.exports